import {
  initializeAuthenticationService,
  initializeThirdParties,
  wrap,
  wrapWithApolloProvider,
  wrapWithInitializationHooks,
  wrapWithLDProvider,
  wrapWithSentryProvider,
  wrapWithToastProvider,
  wrapWithAlertModalProvider,
  wrapWithVersionGuard,
} from '@neo.tax/shared';

import { Base } from './pages';

initializeAuthenticationService();
initializeThirdParties();

export const App = wrap(
  () => <Base />,
  wrapWithAlertModalProvider,
  wrapWithToastProvider,
  wrapWithInitializationHooks,
  wrapWithLDProvider,
  wrapWithSentryProvider,
  wrapWithVersionGuard,
  wrapWithApolloProvider,
);
